import { useEffect } from "react";
import Navbar from "../components/Navbar";

export function AppShell({
  currentPath,
  navigate,
  themeMode,
  toggleTheme,
  children,
}) {
  const isMapPage = currentPath === "/" || currentPath === "";

  useEffect(() => {
    // O mapa ocupa a viewport; as demais páginas permitem rolagem.
    document.body.style.overflowY = isMapPage ? "hidden" : "auto";
    if (!isMapPage) {
      window.scrollTo(0, 0);
    }
  }, [isMapPage]);

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        height: isMapPage ? "100vh" : "auto",
        display: "flex",
        flexDirection: "column",
        background: "var(--bg-app)",
        color: "var(--text-primary)",
        fontFamily: "Inter, sans-serif",
        overflowX: "hidden",
        overflowY: isMapPage ? "hidden" : "visible",
      }}
    >
      <Navbar
        currentPath={currentPath}
        navigate={navigate}
        themeMode={themeMode}
        toggleTheme={toggleTheme}
      />
      <div
        style={{
          flex: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {children}
      </div>
    </div>
  );
}
